/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2024 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    chain,
    DispatchCompleteLoadSession,
} from "@insite/client-framework/Store/Context/Handlers/SetDashboardIsHomepage";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getDataLayer } from "@pacific/XDL/Utilities/dataLayer";

export const _GaSetDashboardIsHomepage: typeof DispatchCompleteLoadSession = props => {
    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }

    const state = props.getState();
    const session = getSession(state);
    const currentBillTo = getCurrentBillToState(state).value;
    const googleAnalyticsData = {
        event: "make_dash_homepg",
        click_text: siteMessage("Dashboard_MakeMyHomepage"),
        destination: "/MyAccount",
        authentication_state: "Authenticated",
        affiliation: currentBillTo?.companyName || "",
        sales_rep: (session as any).salesperson?.name || "",
    };
    dataLayer.push(googleAnalyticsData);
};

addToChainAfter(chain, DispatchCompleteLoadSession, _GaSetDashboardIsHomepage);
